import { render } from "./StockTransferByPhysicalBranch.vue?vue&type=template&id=49592711&scoped=true"
import script from "./StockTransferByPhysicalBranch.vue?vue&type=script&lang=js"
export * from "./StockTransferByPhysicalBranch.vue?vue&type=script&lang=js"

import "./StockTransferByPhysicalBranch.vue?vue&type=style&index=0&id=49592711&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49592711"]])

export default __exports__